import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PageRequest, SpringPage } from '@shared/page';
import { AdminOrganizationService, OrganizationUser } from '@shared/services/admin-organization.service';
import { AdminService, ImpersonateRequest } from '@shared/services/admin.service';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, Subscription, throwError } from 'rxjs';
import { ToastrService } from '@shared/services/toastr.service';
import { ADMIN_PREFIX } from '../../../../../app-routing.constants';
import { USERS_ROUTE } from '../../../admin-routing.module';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { TypedTemplateDirective } from '@shared/directives/typed-template.directive';
import { RouterLink } from '@angular/router';
import { TablePagerComponent } from '@shared/components/table-pager/table-pager.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-organization-users',
  templateUrl: './admin-organization-users.component.html',
  styleUrls: ['./admin-organization-users.component.scss'],
  imports: [NgxDatatableModule, TypedTemplateDirective, RouterLink, TablePagerComponent, TranslatePipe],
})
export class AdminOrganizationUsersComponent implements OnInit, OnDestroy {
  @Input({ required: true }) organizationCode: string;

  data: SpringPage<OrganizationUser> | undefined;
  page: PageRequest = { number: 0, size: 10 };

  subscriptions: Subscription = new Subscription();

  rowType = { row: {} as OrganizationUser };

  constructor(
    private adminService: AdminService,
    private organizationService: AdminOrganizationService,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.refreshData();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  changePage(page: number) {
    this.page = { ...this.page, number: page };
    this.refreshData();
  }

  refreshData() {
    this.subscriptions.add(
      this.organizationService.getOrganizationUsers(this.organizationCode, '', this.page).subscribe({
        next: (response: SpringPage<OrganizationUser>): SpringPage<OrganizationUser> => (this.data = response),
        error: (err: HttpErrorResponse) => catchError(() => throwError(() => this.toastr.error(err?.message))),
      }),
    );
  }

  impersonate(user: ImpersonateRequest) {
    this.adminService.connectAsUser(user, this.organizationCode);
  }

  protected readonly ADMIN_PREFIX = ADMIN_PREFIX;
  protected readonly USERS_ROUTE = USERS_ROUTE;
}
